module.exports = {
      id: "audio-pause-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#audio-pause",
      toString: function () {
        return this.url;
      }
    }